module.exports = __webpack_public_path__ + "static/media/breadcrumb-tail-unselected.b179ea10.svg";